<template>
  <v-alert :value="true" color="error" icon="warning">
    Sorry, nothing to display here :(
  </v-alert>
</template>

<script>
export default {
  name: 'Error'
}
</script>